import {encryptionPassword} from '~/utils/cryptoHelper'
export const state = () => ({
  // api Url
  apiUrl: {
    authenticateUrl: '/api/sm/auth',
    // 시스템 종료
    smShutdownUrl: '/api/sm/shutdown',
    // 시스템 restart
    smRestartUrl: '/api/sm/restart'
  },
  settingModel: {
    stop_id: '',
    stop_passwd: '',
    restart_id: '',
    restart_passwd: ''
  }
})
export const mutations = {
  clearSettingModel (state) {
    state.settingModel = {
      stop_id: '',
      stop_passwd: '',
      restart_id: '',
      restart_passwd: ''
    }
  }
}
export const actions = {
  // 시스템 종료
  async acsPostAdminShutdown ({commit, state, rootState}) {
    const csrfToken = rootState.common.authenticate.encryptionAesKey
    const axiosData = {
      admin_login_uname: state.settingModel.stop_id,
      admin_login_pw: encryptionPassword(csrfToken, state.settingModel.stop_passwd)
    }
    try {
      const data = await this.$axios.$post(`${state.apiUrl.smShutdownUrl}`, axiosData, {successAlert: false, alertMsg: ''})
      if (data.code !== 'ok') {
        return {code: 'nok', error: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', error: error}
    }
  },
  // 시스템 restart
  async acsPostAdminRestart ({commit, state, rootState}) {
    const csrfToken = rootState.common.authenticate.encryptionAesKey
    const axiosData = {
      admin_login_uname: state.settingModel.restart_id,
      admin_login_pw: encryptionPassword(csrfToken, state.settingModel.restart_passwd)
    }
    try {
      const data = await this.$axios.$post(`${state.apiUrl.smRestartUrl}`, axiosData, {successAlert: false, alertMsg: ''})
      if (data.code !== 'ok') {
        return {code: 'nok', error: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', error: error}
    }
  }
  // 권한 체크
  // acsAuthenticate ({commit, state}, payload) {
  // const success = {}
  // success.error = null
  // this.$axios.$post(`${state.apiUrl.authenticateUrl}`, payload)
  //   .then((res) => {
  //     success.result = res
  //     commit('acsAuthenticate', success)
  //   })
  //   .catch((error) => {
  //     success.error = error
  //     commit('mutErrorMessage', success)
  //   })
  // }
}
export const getters = {}
export const strict = false
